import React, {useEffect, useState} from 'react';
import Monto from "../Monto";
import Rendimiento from "../Rendimiento";
import Precio from "../Precio";
import Sector from "../Sector";
import Api from "../Api";
import Loader from "../Loader";
import TaseTipo from "../TaseTipo";
import ExportTable from "../ExportTable";
const api = new Api();

const Adjudicaciones = ({subasta}) => {

    const [ofertas, setOfertas] = useState([]);
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        api.get(`/resultados_subasta_adjudicacion/${subasta?.TASU_IDSUBASTA}`).then((res)=> {
            setShowLoader(false);
            setOfertas(res);
        });
        return () => {

        };
    }, [subasta]);
    
    
    return (
        <>
            <Loader active={showLoader}></Loader>
            <ExportTable fileName={"Adjudicaciones_"+subasta.TATE_EMISION+".csv"}>
                <table className="table">
                    <thead>
                    <tr>
                        <th className="col-1 text-left">Id</th>
                        <th className="col-1 text-left">Adjudicado</th>
                        <th className="col-1 text-left">Rendimiento</th>
                        <th className="col-1 text-left">Precio</th>
                        <th className="col-1 text-left">Negociado</th>
                        <th className="col-1 text-left">Adjudicado Acumulado</th>
                        <th className="col-1 text-left">Negociado Acumulado</th>
                        <th className="col-1 text-left">Intereses Acumulados</th>
                        <th className="col-1 text-left">Tipo</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        !ofertas.length ?  (<tr><td className="text-left font-weight-bolder text-uppercase" colSpan={"3"}>No existen Ofertas para el criterio de busqueda.</td></tr>) : (<tr className="d-none"><td colSpan={"3"}></td></tr>)
                    }
                    {
                        ofertas.map((oferta,key)=> {
                            return (
                                <tr key={'s'+key}>
                                    <td className="text-left">{oferta.TACV_CODCASA}-{oferta.TASE_IDOFERTA}</td>
                                    <td className="text-left">{<Monto tipoEmision={subasta.TATE_TIPEMISION} value={oferta.TASE_ADJUDICADO}/>}</td>
                                    <td className="text-left">{<Rendimiento value={oferta.TASE_RENDIMIENTO}/>}</td>
                                    <td className="text-left">{<Precio tipoEmision={subasta.TATE_TIPEMISION} value={oferta.TASE_PRECIO}/>}</td>
                                    <td className="text-left">{<Monto tipoEmision={subasta.TATE_TIPEMISION} value={oferta.TASE_NEGOCIADO}/>}</td>
                                    <td className="text-left">{<Monto tipoEmision={subasta.TATE_TIPEMISION} value={oferta.TASE_ADJUDICADO_ACUMULADO}/>}</td>
                                    <td className="text-left">{<Precio tipoEmision={subasta.TATE_TIPEMISION} value={oferta.TASE_PRECIO_PONDERADO}/>}</td>
                                    <td className="text-left">{Number(oferta.TASE_INTERESES_ACUMULADOS).toFixed(3)}</td>
                                    <td className="text-left">{<TaseTipo tipo={oferta.TAOF_TIPO} sector={oferta.TAOF_SECTOR} />}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </ExportTable>
        </>
    );
};

export default Adjudicaciones;
